import { useState } from 'react';

export const useExpandedRows = () => {
  const [expandedRows, setExpandedRows] = useState<number[]>([]);
  const onRowToggled = (id: number) => {
    setExpandedRows((prev) => {
      if (prev && prev.includes(id)) {
        return prev.filter((expanded) => expanded !== id);
      }

      return [...prev, id];
    });
  };

  return {
    expandedRows,
    onRowToggled
  };
};
